import { Component, OnInit, Output, ViewChild, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'lib-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output() userSelectedDate = new EventEmitter();

  myCalendar: any;
  calenderDate: any;
  currentDate: any;
  calenderCurrentDate: any;
  todayDate: any;
  refreshTimer = 0;
  refreshInterval: any;
  calenderEvent: any;
  message: any;
  intervalId: any;

  constructor() { }

  ngOnInit(): void {
    this.getDefaultDate();
    this.startTimer();
   
  }


  getDefaultDate() {
    let date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let m;
    let d;
    if (month < 10) {
      m = "0" + month;
    } else {
      m = month;
    }
    if (day < 10) {
      d = "0" + day;
    } else {
      d = day;
    }
    let today = year + "-" + m + "-" + d;
    this.currentDate = today;
    this.todayDate = today.split("-").reverse().join("-");
    this.calenderCurrentDate = today.split("-").reverse().join("-");
  }
  selectDate(e: any) {
    this.calenderEvent = e;
    let today = e.target.value;
    // console.log("e.target.value", e.target.value);
    today = today.split("-").reverse().join("-");
    this.calenderCurrentDate = today;
   
    this.refreshChart();
    // this.userSelectedDate.emit(this.calenderCurrentDate);
    ;
    console.log(" IN --> 5");
  }
  refreshChart() {
    this.stopTimer();
    this.refreshTimer = 0;
    this.countDown();
    this.userSelectedDate.emit(this.calenderCurrentDate);
  }

  startTimer() {
    this.countDown();
  }
  stopTimer() {

    this.clearTimer();
    this.message = ``;
  }
  clearTimer() {
    this.refreshTimer = 0;
    window.clearInterval(this.intervalId);
  }
  countDown() {
    this.clearTimer();
    this.intervalId = window.setInterval(() => {
      this.refreshTimer -= 1;
      if (this.refreshTimer === 0) {
        this.refreshChart();
        this.message = '';
      } else {
        if (this.refreshTimer < 0) {
          this.refreshTimer = 300;
        } // reset
        this.message = `${this.refreshTimer}`;
      }
    }, 1000);
  }
  timeConvert(n: any) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + ':' + rminutes;
  }
  exportReport(){
    
  }
  ngOnDestroy() {
    this.clearTimer();
  }
}
